import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ContextMenuService} from "../../../../services/context-menu.service";

@Component({
  selector: 'app-user-context-menu',
  templateUrl: './user-context-menu.component.html',
  styleUrls: ['./user-context-menu.component.scss']
})
export class UserContextMenuComponent {
  @Input() userId: number | undefined
  @Input() status!: boolean

  @Output() editUserEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() changeStatusEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() resetSessionEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() resetPasswordEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() deleteUserEvent: EventEmitter<number> = new EventEmitter<number>()


  constructor(
    private contextMenuService: ContextMenuService
  ) {
  }

  editUser() {
    this.editUserEvent.emit(this.userId)
    this.contextMenuService.statusMenu$.next(false)
  }

  changeStatus() {
    this.changeStatusEvent.emit(this.userId)
    this.contextMenuService.statusMenu$.next(false)
  }

  resetSession() {
    this.resetSessionEvent.emit(this.userId)
    this.contextMenuService.statusMenu$.next(false)
  }

  resetPassword() {
    this.resetPasswordEvent.emit(this.userId)
    this.contextMenuService.statusMenu$.next(false)
  }

  deleteUser() {
    this.deleteUserEvent.emit(this.userId)
    this.contextMenuService.statusMenu$.next(false)
  }
}
